import httpClient from '@/http-client'

export const getTotal = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/total-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudentStatus = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/student-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getSaleItem = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/sale-items', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchUnpaidStudent = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/unpaid-students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchIncomeByFee = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/income-by-fees', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getTotalStudent = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/total-students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudentAttendance = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/student-attendances', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudentGrade = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/student-grades', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const fetchCampusAndStudentPickup = (Options = {}) => {
  return httpClient
    .get('/api/dashboard/campus-attendances-and-student-pickups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  getTotal,
  getStudentStatus,
  getSaleItem,
  fetchUnpaidStudent,
  fetchIncomeByFee,
  getTotalStudent,
  getStudentAttendance,
  getStudentGrade,
  fetchCampusAndStudentPickup
}
